export default [
  {
    path: "/admin",
    component: () => import("@/views/admin/AdminLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: { name: "admin-home" },
      },
      {
        path: "home",
        name: "admin-home",
        component: () => import("@/views/admin/MenuAdmin.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "menu",
        redirect: { name: "admin-home" },
      },
      {
        path: "admin-dashboard",
        name: "admin-dashboard",
        redirect: { name: "admin-home" },
      },
      {
        path: "validar-cpa",
        name: "validar-cpa",
        component: () => import("@/views/admin/ValidarCpa.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "crear-colegio",
        name: "crear-colegio",
        component: () => import("@/views/admin/CrearColegio.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "buscar-colegio",
        name: "buscar-colegio",
        component: () => import("@/views/admin/BucarColegio.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "menu-colegio",
        name: "menu-colegio",
        component: () => import("@/views/admin/MenuColegio.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "menu-grupo-admin",
        name: "menu-grupo-admin",
        component: () => import("@/views/admin/MenuCurso.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, requiresCurso: true },
      },
      {
        path: "curso/apoderados",
        name: "admin-ver-apoderados",
        component: () => import("@/views/user/VerApoderados.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, requiresCurso: true },
      },
      {
        path: "curso/directiva",
        name: "admin-modificar-directiva",
        component: () => import("@/views/user/ModificarDirectiva.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, requiresCurso: true },
      },
      {
        path: "menu-todos-cursos",
        name: "menu-todos-cursos",
        component: () => import("@/views/admin/MenuTodosLosCursos.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "carga-directivas-excel",
        name: "carga-directivas-excel",
        component: () => import("@/views/admin/CargaDirectivasDesdeExcel.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "crear-link-directivas",
        name: "crear-link-directivas",
        component: () => import("@/views/admin/CreaLinkAsociarDirectivas.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "soporte",
        name: "admin-soporte",
        component: () => import("@/views/admin/AdminSoporte.vue"),
        meta: {
          requiresAuth: true,
          requiresSupportAgent: true,
        },
      },
      {
        path: "permisos",
        name: "admin-permisos",
        component: () => import("@/views/admin/AdminPermisos.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "operacion",
        name: "admin-operacion",
        component: () => import("@/views/admin/AdminOperacion.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "usuarios",
        name: "admin-usuarios",
        component: () => import("@/views/admin/AdminUsuarios.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "versiones",
        name: "admin-versiones",
        component: () => import("@/views/admin/AdminVersiones.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "reportes",
        name: "admin-reportes",
        component: () => import("@/views/admin/AdminReportes.vue"),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },
];
